import { AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, filter, fromEvent, Subscription, tap } from 'rxjs';
import * as _ from 'lodash';
import { NgFor, NgIf } from '@angular/common';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClickOutsideAttachOutsideDirective, NgClickOutsideDirective } from 'ng-click-outside2';

@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [NgIf, NgFor, NgClickOutsideDirective, NgClickOutsideAttachOutsideDirective],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownComponent),
      multi: true
    }
  ],
})
export class DropdownComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() items: any[] = [];
  @Input() fieldToShow = '';
  @Input() fieldToSave = '';
  @Input() prefixField = '';  // optional per-item field rendered as a muted prefix before fieldToShow. Ex: "1 - ABC123"
  @Input() label = '';
  @Input() disabled = false;
  @Input() defaultTitle = '';
  @Input() enableFilter = false;
  @Input() isFromBuyerPortal = false;
  @Input() showCostPopup = false;
  @Input() hideSelectedValueFromOptions = false;
  @Input() showInRed = false;
  @Input() muteClick = false;
  @Input() counterFieldForDropdownOption = '';  // field that will be concatenated at the end of each option of the dropdown. Ex: Option1 (25)
  @Input() titlePrefix = '';
  @Input() darkTheme = false;
  @Input() whiteBorderedTheme = false;
  @Input() offersSelect = false;
  @Input() displayCounterInSelectedTitle = false;
  @Input() filterPlaceholder = '';
  @Input() enableLazyLoad = false;
  @Input() isLoading = false;
  @Input() hasMoreItems = true;
  @Output() onSelect = new EventEmitter();
  @Output() onOpen = new EventEmitter<void>();
  @Output() onScrollEnd = new EventEmitter<void>();
  @ViewChild('inputFilter') inputFilter!: ElementRef;
  @ViewChild('dropdownResults') dropdownResults!: ElementRef;

  itemsCopy: any[] = [];
  expanded = false;
  selectedTitle = '';
  selectedValue = '';

  sufix = '';
  firstTimeFiltering = true;
  selectedValueBelongToFilteredList = true;
  showNoResultsFound = false;
  subscriptions: Subscription[] = [];
  private scrollListenerSetup = false;

  constructor(private elemR: ElementRef,
    // private pubSubService: PubSubService,
    private router: Router) {
    this.setSubscriptions();
  }

  ngOnInit() {
    this.sufix = this.getSufixForId();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] && !changes['items'].firstChange && !this.firstTimeFiltering) {
      this.firstTimeFiltering = true;
      this.itemsCopy = [];
    }
  }

  ngAfterViewInit() {
    if (this.enableFilter) {
      fromEvent(this.inputFilter.nativeElement, 'keyup')
        .pipe(
          filter(Boolean),
          debounceTime(250),
          distinctUntilChanged(),
          tap((text) => {
            this.filter();
          })
        )
        .subscribe();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  setSubscriptions() {
    // this.subscriptions.push(
    //   this.pubSubService.sharedSubject.subscribe(
    //     myEvent => {
    //       if (myEvent.name === SharedSource.closeAllDropdowns) {
    //         this.expanded = false;
    //       } else if (myEvent.name === SharedSource.updateOffersByStatusDropdown && this.router.url.match(/offers/) && this.offersSelect) {
    //         this.writeValue(myEvent.data as FullOfferStatusEnum)
    //       }
    //     })
    // );
  }

  toggleDropdown() {
    if (this.disabled || this.muteClick) {
      return;
    }
    const wasExpanded = this.expanded;
    this.expanded = !this.expanded;

    // Emit onOpen when dropdown opens
    if (!wasExpanded && this.expanded) {
      this.onOpen.emit();

      // Setup scroll listener on first open
      if (this.enableLazyLoad && !this.scrollListenerSetup) {
        this.setupScrollListener();
      }
    }
  }

  onSelectItem(item: any, e?: Event) {
    if (item.dropdownOptionDisabled && e) {
      e.stopPropagation();
      return;
    }
    this.resetFilter();
    if (this.selectedValue === item[this.fieldToSave]) {
      return;
    }

    const oldValue = this.selectedValue;
    this.selectedTitle = item[this.fieldToShow];
    this.selectedValue = item[this.fieldToSave];
    this.emitChanges(); // to make "the 2 way data binding" work

    item.oldValue = oldValue;
    this.onSelect.emit(item);
  }

  getTitle(): string {
    const selected = this.items.find(x => x[this.fieldToSave] === this.selectedValue);
    if (selected) {
      const counterLabel = (this.displayCounterInSelectedTitle) ? ` ${this.getCustomDropdownOption(selected)}` : '';
      this.selectedTitle = selected[this.fieldToShow] + counterLabel;
    } else {
      return this.defaultTitle;
    }
    return this.selectedTitle;
  }

  /** Prefix string for the currently-selected item, used to color the line marker in the collapsed toggle. */
  getSelectedPrefix(): string {
    if (!this.prefixField) {
      return '';
    }
    const selected = this.items?.find(x => x[this.fieldToSave] === this.selectedValue);
    return selected && selected[this.prefixField] != null ? selected[this.prefixField] : '';
  }

  onChange = (_: any) => { };

  emitChanges() {
    this.onChange(this.selectedValue);
  }

  writeValue(val: any): void {
    this.selectedValue = val;
    const selected = this.items.find(x => x[this.fieldToSave] === this.selectedValue);
    if (selected) {
      this.selectedTitle = selected[this.fieldToShow];
    }
    this.emitChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void { }


  // FILTER
  getSufixForId(): string {
    return Math.random()   // Generate random number, eg: 0.123456
      .toString(36) // Convert  to base-36 : "0.4fzyo82mvyr"
      .slice(-4);   // Cut off last 4 characters : "mvyr"
  }

  stopPropagation(e: Event): void {
    e.stopPropagation();
  }

  filter() {
    if (!this.enableFilter) {
      return;
    }

    if (this.firstTimeFiltering) { // need to be here because array can be empty at the begining "onInit"
      this.itemsCopy = _.cloneDeep(this.items);
      this.firstTimeFiltering = false;
    }
    this.items = _.cloneDeep(this.itemsCopy);
    let filterValue = this.elemR.nativeElement.querySelector(`#ddf_${this.sufix}`).value;

    if (filterValue && filterValue.length) {
      filterValue = filterValue.trim();
    }

    // filtering the list but keeping the selected value in the list to be able to show the selected value in the dropdown
    this.items = this.items.filter(x =>
      x[this.fieldToSave] === this.selectedValue ||
      x[this.fieldToShow].toLowerCase().includes(filterValue.toLowerCase()));

    // show the current selected value just in case belongs to the filtered list
    const filteredList = this.itemsCopy.filter(x => x[this.fieldToShow].toLowerCase().includes(filterValue.toLowerCase()));
    const selected = filteredList.find(x => x[this.fieldToSave] === this.selectedValue);
    this.selectedValueBelongToFilteredList = selected ? true : false;

    // Show no results found
    if (!this.selectedValue) {
      this.showNoResultsFound = !this.items.length ? true : false;
    } else {
      if (this.selectedValueBelongToFilteredList) {
        this.showNoResultsFound = !this.items.length ? true : false;
      } else {
        this.showNoResultsFound = !(this.items.length - 1) ? true : false;
      }
    }
  }


  onKeyupEnter(e: any) {
    if (!e.target.value || !this.enableFilter) {
      return;
    }
    if ((!this.selectedValue && this.items.length) || (this.selectedValue && this.selectedValueBelongToFilteredList)) {
      this.onSelectItem(this.items[0]);
      this.expanded = false;
    }

    if (this.selectedValue && !this.selectedValueBelongToFilteredList) {
      const filteredListWithoutTheSelected = this.items.filter(x => x[this.fieldToSave] !== this.selectedValue);
      if (filteredListWithoutTheSelected.length) {
        this.onSelectItem(filteredListWithoutTheSelected[0]);
        this.expanded = false;
      }
    }
  }

  onKeydownEsc(event: Event) {
    if (!this.enableFilter) {
      return;
    }
    this.resetFilter();
    this.expanded = false;
  }

  resetFilter() {
    if (!this.enableFilter) {
      return;
    }
    const filterInput = this.elemR.nativeElement.querySelector(`#ddf_${this.sufix}`);
    if (filterInput.value) {
      this.showNoResultsFound = false;
      filterInput.value = '';
      this.selectedValueBelongToFilteredList = true;
      this.items = _.cloneDeep(this.itemsCopy);
    }
  }

  setFocusToFilter() {
    this.resetFilter();
    if (!this.expanded && this.enableFilter) {
      setTimeout(() => { this.elemR.nativeElement.querySelector(`#ddf_${this.sufix}`).focus(); });
    }
  }

  onClickOutside() {
    this.expanded = false;
    this.resetFilter();
  }

  getCustomDropdownOption(item: any): string {
    if (!this.counterFieldForDropdownOption || !item[this.counterFieldForDropdownOption] || item[this.counterFieldForDropdownOption] === null) {
      return '';
    }
    return `(${item[this.counterFieldForDropdownOption]})`
  }

  onScroll(): void {
    if (!this.enableLazyLoad || this.isLoading || !this.hasMoreItems) {
      return;
    }

    const element = this.dropdownResults.nativeElement;
    const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    if (atBottom) {
      this.onScrollEnd.emit();
    }
  }

  private setupScrollListener(): void {
    setTimeout(() => {
      if (this.dropdownResults?.nativeElement && !this.scrollListenerSetup) {
        const sub = fromEvent(this.dropdownResults.nativeElement, 'scroll')
          .pipe(
            debounceTime(200),
            tap(() => this.onScroll())
          )
          .subscribe();
        this.subscriptions.push(sub);
        this.scrollListenerSetup = true;
      }
    }, 100);
  }

}
